<template>
  <fragment>
    <app-header title="Rail Application Version History and Change Log">
      <template #actions>
        <router-link :to="{ name: 'settings.rail-app-release.add' }" as="button" class="btn btn-primary">
          <i class="far fa-plus"></i> Change Logs
        </router-link>
      </template>
    </app-header>

    <div class="cotnainer-fluid px-4 pt-4">
      <app-release-filters v-model="params"/>

      <c-data-list class="list-data-app-release" :items="railAppReleases" @load="load">
        <template #columns>
          <div class="col-sm-2">Version</div>
          <div class="col-sm-2 col-xl-2">Released at</div>
          <div class="col-xl-6">Change Logs</div>
          <div class="col-xl-1">Status</div>
          <div class="col-xl-1"></div>
        </template>
        <template #default="{ item }">
          <router-link tag="a" :to="{ name: 'settings.rail-app-release.single', params: { releaseId: item.id }}">
            <div class="row align-items-start">
              <div class="col-sm-2">
                <p>
                  <span class="data-label d-xl-none">Version Name</span>
                  {{ item.name }}
                </p>
              </div>
              <div class="col-sm-2">
                <p>
                  <span class="data-label d-xl-none">Released at</span>
                  {{ item.released_at }}
                </p>
              </div>
              <div class="col-sm-6">
                <p>
                  <span class="data-label d-xl-none">Change Logs</span>
                  <span v-html="item.html_content">
                </span>
                </p>
              </div>
              <div class="col-sm-1">
                <span class="status status-success" v-if="item.status === 'current'">Current</span>
                <span class="status status-info" v-if="item.status === 'testing'">Testing</span>
                <span class="status status-danger" v-if="item.status === 'legacy'">Legacy</span>
              </div>
              <div class="col-xl-1 text-end">
                <button type="button" class="btn btn-sm text-warning" @click.prevent="deleteItem(item)">
                  <i class="far fa-archive"></i>
                </button>
              </div>
            </div>
          </router-link>
        </template>
      </c-data-list>
    </div>
  </fragment>
</template>
<script>
import { helperComputed, helperMethods } from '@/vuex/modules/settings/rail-app-releases'
import swal from 'sweetalert'
import { compareQueryParams } from '@codium/codium-vue'
import AppReleaseFilters from './AppReleaseFilters'

export default {
  watch: {
    params: compareQueryParams(async function (params) {
      await this.getRailAppReleases({ params, fresh: true })
    })
  },

  beforeDestroy () {
    this.resetRailAppRelease()
  },

  data () {
    return {
      params: null
    }
  },

  components: {
    AppReleaseFilters
  },

  computed: {
    ...helperComputed
  },

  methods: {
    ...helperMethods,

    async deleteItem (item) {
      if (!await swal({
        text: 'Are you sure you want to delete this release history entry? This action cannot be undone.',
        buttons: {
          ok: { text: 'Yes', visible: true, className: 'btn btn-danger' },
          cancel: { text: 'No', visible: true, className: 'btn btn-light' }
        },
        dangerMode: true
      })) {
        return
      }

      await this.deleteRailAppRelease(item.id)
    },

    async load (done) {
      const { params } = this

      try {
        await this.getRailAppReleases({ params })

        done()
      } catch {
        done(true)
      }
    }
  }
}
</script>

<style lang="scss">
.list-data.list-data-app-release > li {
  p, span {
    white-space: normal;
  }
}
</style>
